<ng-template #footer2Template let-aggregates="aggregates" let-field="field" let-aggregate="aggregate">
    <ng-container [ngSwitch]="aggregate">
        <span *ngSwitchCase="'sum'">
            {{aggregates[field]?.sum  | kendoNumber: '#,##0.00'}}
        </span>
        <span *ngSwitchCase="'min'">
            {{aggregates[field]?.min  | kendoNumber: '#,##0.00'}}
        </span>
        <span *ngSwitchCase="'max'">
            {{aggregates[field]?.max  | kendoNumber: '#,##0.00'}}
        </span>
        <span *ngSwitchCase="'average'">
            {{aggregates[field]?.average  | kendoNumber: '#,##0.00'}}
        </span>
    </ng-container>
</ng-template>

<div *ngIf="gridData" [@animationState]="animate ? 'active' : 'inactive'">
    <h5 *ngIf="pageTitleEnable">{{pageTitle}}</h5>
    <div *ngIf="filterPanelEnable" [@menu]="'inline'">
        <kendo-filter [filters]="filterExpressions"
                      [value]="filterValue"
                      (valueChange)="onFilterChange($event)">
        </kendo-filter>
        <div class="k-dialog-actions k-actions-srart" style="border-color: #e0e0e0">
            <button kendoButton (click)="applyFilter()" themeColor="primary">{{applyLabel}}</button>
        </div>
    </div>
    <!--Next version <div>{{filterDiscription}}</div> -->
    <kendo-grid #grid [data]="gridData"
                [pageable]="pager"
                [kendoGridSelectBy]="dataKey"
                [(selectedKeys)]="selectedKeys"
                [selectable]="selectable"
                [height]="height"
                [resizable]="resizable"
                [reorderable]="reorderable"
                [columnMenu]="columnMenu"
                [loading]="loading"
                [pageSize]="state.take"
                [skip]="state.skip"
                [sortable]="sortable"
                [sort]="state.sort"
                [groupable]="groupable"
                [group]="state.group"
                [filterable]="false"
                [filter]="state.filter"
                [trackBy]="trackByItem"
                (cellClick)="onCellClick($event)"
                (dblclick)="onDblClick($event)"
                (columnReorder)="onReorder($event)"
                (columnResize)="onResize($event)"
                (columnVisibilityChange)="onVisibilityChange($event)"
                (dataStateChange)="dataStateChange($event)">
        <ng-template kendoGridToolbarTemplate>
            <ng-container *ngIf="quickSearchEnable">
                <div #wrapper kendoGridToolbarFocusable (keydown.enter)="textbox.focus()">
                    <kendo-textbox #textbox
                                   name="quickSearch"
                                   [placeholder]="searchLabel"
                                   [style.width.em]="20"
                                   (click)="onQuickSearchClick($event)"
                                   (keydown)="onQuickSearchKeydown($event, wrapper)"
                                   (afterValueChanged)="onQuickSearchValueChange($event)">
                    </kendo-textbox>
                </div>
            </ng-container>
            <div *ngIf="selectedKeys.length>0">({{ selectedKeys.length }}/{{ gridData.total }})</div>

            <kendo-grid-spacer></kendo-grid-spacer>
            <button *ngIf="excelCommandEnable" kendoGridExcelCommand themeColor="warning" [svgIcon]="fileExcelIcon"></button>
            <button *ngIf="pdfCommandEnable" kendoGridPDFCommand themeColor="warning" [svgIcon]="filePdfIcon"></button>
            <button kendoButton (click)="grid.autoFitColumns()" themeColor="primary" [svgIcon]="colResizeIcon" [title]="autofitColumnsLabel"></button>

            <span class="k-separator" style="color: #fafafa"></span>
            <kendo-dropdownbutton *ngIf="customMenuEnable"
                                  [data]="customMenuData"
                                  [popupSettings]="{ align: 'right' }"
                                  [title]="customMenuLabel"
                                  iconClass="k-icon k-font-icon k-i-cog">
            </kendo-dropdownbutton>

            <kendo-dropdownbutton *ngIf="settingsMenuEnable"
                                  [data]="settingsMenuData"
                                  [popupSettings]="{ align: 'right', popupClass: 'dropdown-grid-popup' }"
                                  [title]="settingsMenuLabel"
                                  [svgIcon]="tableIcon">
            </kendo-dropdownbutton>
            <kendo-grid-column-chooser *ngIf="columnChooserCommandEnable"></kendo-grid-column-chooser>
            <button *ngIf="filterCommandEnable" kendoButton iconClass="k-icon k-font-icon k-i-filter" (click)="toggleFilterPanel()"></button>

            <kendo-grid-spacer *ngIf="toolbalSeparatorEnable"></kendo-grid-spacer>
            <button *ngIf="insertCommandEnable" kendoButton iconClass="k-icon k-font-icon k-i-plus !k-color-primary" (click)="insertCommand()">{{insertLabel}}</button>
            <button *ngIf="deleteCommandEnable" kendoButton iconClass="k-icon k-font-icon k-i-trash !k-color-error" [disabled]="selectedKeys.length == 0" (click)="deleteCommand()">{{deleteLabel}}</button>

        </ng-template>

        <kendo-grid-checkbox-column *ngIf="checkboxColumnEnable"
                                    [width]="45"
                                    [headerClass]="{ 'text-center': true }"
                                    [class]="{ 'text-center': true, 'k-grid-checkbox-column': true }"
                                    [resizable]="false"
                                    [columnMenu]="false"
                                    [showSelectAll]="showSelectAllEnable">
        </kendo-grid-checkbox-column>
        <kendo-grid-column *ngFor="let col of columns"
                           [field]="col.field"
                           [title]="col.title"
                           [width]="col.width"
                           [filter]="col.filter"
                           [sortable]="col.sortable"
                           [groupable]="col.groupable"
                           [filterable]="col.filterable"
                           [hidden]="col.hidden"
                           [format]="col.format"
                           [style]="col.style"
                           [class]="col.class">
            <!--        <ng-template *ngIf="col.templateRef" kendoGridCellTemplate let-dataItem="dataItem">
                   <ng-container *ngTemplateOutlet="col.templateRef; context: { dataItem: dataItem }"></ng-container>
               </ng-template>
    -->
            <!--        <ng-template kendoGridFilterMenuTemplate
                            let-column="column"
                            let-filter="filter"
                            let-filterService="filterService">
                   <multicheck-filter [isPrimitive]="true"
                                      [field]="column.field"
                                      [filterService]="filterService"
                                      [currentFilter]="filter"
                                      [data]="distinctPrimitive(column.field)"></multicheck-filter>
               </ng-template>
    -->
            <!-- <ng-template kendoGridGroupFooterTemplate let-group="group">
        <span> {{ group.value }} </span>
    </ng-template> -->

            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                <span>{{ groupHeaderTemplate(value) }}</span>
            </ng-template>

            <ng-container *ngIf="aggregatable">

                <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                    <ng-container *ngTemplateOutlet="aggregateTemplates[col.field]; context: { aggregates: aggregates }">
                    </ng-container>
                    <!-- <ng-container *ngTemplateOutlet="footerTemplate; context: { aggregates, field: col.field, aggregate: getOperator(col.field) }"></ng-container> -->
                </ng-template>
            </ng-container>

            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <ng-container [ngSwitch]="col.columnType">

                    <!-- Link case -->
                    <ng-container *ngSwitchCase="'link'">
                        <span class="routerLink-column">
                            <a [routerLink]="['/' + pathUrl, dataItem[dataKey]]" [attr.target]="col.target">
                                {{dataItem[col.field]}}
                            </a>
                        </span>
                    </ng-container>

                    <!-- Numeric case -->
                    <ng-container *ngSwitchCase="'numeric'">
                        <span>{{ dataItem[col.field] | kendoNumber: '#,##0' }}</span>
                    </ng-container>

                    <!-- Button case -->
                    <ng-container *ngSwitchCase="'button'">
                        <ng-container *ngTemplateOutlet="buttonTemplates[col.field]; context: { dataItem: dataItem }">
                        </ng-container>
                    </ng-container>

                    <!-- Decimal case -->
                    <ng-container *ngSwitchCase="'decimal'">
                        <span>{{ dataItem[col.field] | kendoNumber: '#,##0.00' }}</span>
                    </ng-container>

                    <!-- Date case -->
                    <ng-container *ngSwitchCase="'date'">
                        <span>{{ dataItem[col.field] | kendoDate: 'd' }}</span>
                    </ng-container>

                    <!-- DateTime case -->
                    <ng-container *ngSwitchCase="'date-time'">
                        <span>{{ dataItem[col.field] | kendoDate: 'g' }}</span>
                    </ng-container>

                    <!-- Time case -->
                    <ng-container *ngSwitchCase="'time'">
                        <span>{{ dataItem[col.field] | kendoDate: 'HH:mm' }}</span>
                    </ng-container>

                    <!-- checkbox case -->
                    <ng-container *ngSwitchCase="'checkbox'">
                        <kendo-svg-icon *ngIf="dataItem[col.field]" [icon]="checkOutlineIcon" themeColor="success" size="large"></kendo-svg-icon>
                        <kendo-svg-icon *ngIf="!dataItem[col.field]" [icon]="minusOutlineIcon" themeColor="error" size="large"></kendo-svg-icon>
                    </ng-container>

                    <!-- Switch case -->
                    <ng-container *ngSwitchCase="'switch'">
                        <span>
                            <kendo-switch [readonly]="true" [checked]="dataItem[col.field]"
                                          [size]="'small'" [onLabel]="''" [offLabel]="''">
                            </kendo-switch>
                        </span>
                    </ng-container>

                    <!-- Default case -->
                    <ng-container *ngSwitchDefault>
                        <span>{{ dataItem[col.field] }}</span>
                    </ng-container>
                </ng-container>
            </ng-template>
        </kendo-grid-column>
        <!--
           <ng-template *kendoGridDetailTemplate="let dataItem">
               <ng-container *ngIf="detailTemplate">
                   <ng-container *ngTemplateOutlet="detailTemplate; context: { dataItem: dataItem }"></ng-container>
               </ng-container>
           </ng-template>
    -->
        <ng-container *ngIf="detailTemplate">

            <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex" [kendoGridDetailTemplateShowIf]="detailTemplateShowIf">
                <ng-container *ngTemplateOutlet="detailTemplate; context: {$implicit: dataItem, rowIndex:rowIndex}"></ng-container>
            </ng-template>

        </ng-container>

        <kendo-grid-excel fileName="excelGrid.xlsx"></kendo-grid-excel>
        <kendo-grid-pdf fileName="printGrid.pdf"
                        [allPages]="true"
                        paperSize="A4"
                        margin="1cm"
                        [scale]="0.6"
                        [repeatHeaders]="true">
            <ng-template kendoGridPDFTemplate
                         let-pageNum="pageNum"
                         let-totalPages="totalPages">
                <div class="page-template">
                    <div class="footer">Page {{ pageNum }} of {{ totalPages }}</div>
                </div>
            </ng-template>
        </kendo-grid-pdf>
    </kendo-grid>

</div>
<!-- <ng-container #dialogContainer></ng-container> -->
